import React, { useState, useContext, FC } from 'react'
import { Grid, Button, Input, FormControl, FormHelperText } from '@material-ui/core'
import Auth from '@aws-amplify/auth'
import { useHistory } from 'react-router-dom'
import { SignupContext } from '../../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../../utils/constants'

const ConfirmationForm: FC = () => {
  const [confirmCode, setConfirmCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { email, password, setUser, setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  const [errMsg, setErrMsg] = useState('')

  const handleConfirmationSubmit = async (): Promise<void> => {
    setErrMsg('')
    setIsLoading(true)
    try {
      await Auth.confirmSignUp(email, confirmCode)
      await Auth.signIn(email, password)
      const user = await Auth.currentUserInfo()
      setUser(user)
      setSignupStep(SIGNUP_STEPS.PLAN)
      history.push('/client/billing')
    } catch (e) {
      setErrMsg(e.message)
    }
    setIsLoading(false)
  }

  return (
    <div className="signup-form">
      <p className="sub-title">Please check your email for a confirmation code to proceed</p>
      <div className="form">
        <FormControl>
          <Input
            id="confirmCode"
            placeholder="CONFIRMATION CODE"
            autoFocus
            type="text"
            fullWidth
            value={confirmCode}
            onChange={(e): void => setConfirmCode(e.target.value)}
          />
          {errMsg && <FormHelperText error>{errMsg}</FormHelperText>}
        </FormControl>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Button
              size="large"
              fullWidth
              variant="contained"
              color="primary"
              disabled={!confirmCode || isLoading}
              onClick={handleConfirmationSubmit}
            >
              SUBMIT CODE
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
export default ConfirmationForm
